<div class="modal-dialog session-timeout-dialog-container">
	<div class="modal-content" cdkTrapFocus #content>
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="modal-session-timeout_session-timed-out"></h4>
		</div>
		<div class="goreact-modal-body">
			<form [formGroup]="form" (ngSubmit)="login()">
				<mat-form-field appearance="outline">
					<mat-label translate="login-form_email-label"></mat-label>
					<input id="email" type="email" name="email" data-cy="login-email-field" matInput formControlName="email" maxlength="100" class="fullstory-ignore"/>
					<mat-error *ngIf="form.controls.email.hasError('email')" translate="sign-up-form-validation-email-invalid"></mat-error>
					<mat-error *ngIf="form.controls.email.hasError('required')" translate="sign-up-form-validation-email-required"></mat-error>
				</mat-form-field>

				<mat-form-field appearance="outline" goPasswordVisibilityToggle>
					<mat-label translate="login-form_password-label"></mat-label>
					<input id="password" type="password" name="password" data-cy="login-password-field" matInput formControlName="password" class="fullstory-ignore" />
					<mat-error *ngIf="form.controls.password.invalid" translate="login-form_validation-password-invalid"></mat-error>
				</mat-form-field>
				<div role="alert" class="error-message" *ngIf="formError$ | async as formError">{{formError}}</div>
				<div class="form-group login-options-wrapper">
					<button
						class="primary-btn sign-in-btn"
						type="submit"
						[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
						translate="common_login"
						[disabled]="loading$ | async">
					</button>
					<sso-provider-button
						(onLoginWithSso)="loginWithSso($event)">
					</sso-provider-button>
				</div>
			</form>
		</div>
	</div>
</div>
